import angular from 'angular';
import ngRoute from 'angular-route';
import ngCookies from 'angular-cookies';
import ngSanitize from 'angular-sanitize';
import rx from 'rx-angular';
import moment from 'moment';
import './lib/ui-bootstrap-tpls-0.6.0.min.js';
import './lib/c3.min.js';
import './lib/ng-infinite-scroll-fork.js';
import { scLayoutModule } from './layout/layout.module';
import { Filter } from './common/filter';

/* global gettext */

angular
  .module('staffcop', [
    scLayoutModule,
    ngRoute, ngCookies, ngSanitize, 'rx',
    'ui.bootstrap',
    'infinite-scrollfork',
    'bgDirectives',
  ])
  .config([
    '$routeProvider', function ($routeProvider) {
      $routeProvider
        .when(
          '/',
          {
            templateUrl   : '/analytics/root.html',
            controller    : 'RootCtrl',
            reloadOnSearch: false,
          },
        )
      ;
    },
  ])
  .config(function () {
    // Init moment.js locale
    let locale = window.navigator.userLanguage || window.navigator.language;
    moment.locale(locale);
  })
  .config(function ($compileProvider) {
    // configure compiler
    // $compileProvider.preAssignBindingsEnabled(true);
    $compileProvider.commentDirectivesEnabled(false);
    // $compileProvider.cssClassDirectivesEnabled(false);
    $compileProvider.debugInfoEnabled(true);
  })
  .config(function ($qProvider) {
    // unhandled rejection
    // $qProvider.errorOnUnhandledRejections(false);
  })
  .run(function (rx, $q) {
    rx.config.Promise = $q;
  })
  .run(function ($rootScope) {
    // localization helpers
    $rootScope.interpolate = interpolate;
    $rootScope.gettext = gettext;
  })
  .filter('trusted', [
    '$sce', function ($sce) {
      return url => $sce.trustAsResourceUrl(url);
    },
  ])
  .run(function ($filter) {
    Filter.formatDate = function (date, format) {
      return $filter('date')(date, format);
    };
  });



// WEBPACK FOOTER //
// ./src/sc.module.js